import { render, staticRenderFns } from "./AlbumPhotos.vue?vue&type=template&id=96e50448&scoped=true&"
import script from "./AlbumPhotos.vue?vue&type=script&lang=js&"
export * from "./AlbumPhotos.vue?vue&type=script&lang=js&"
import style0 from "./AlbumPhotos.vue?vue&type=style&index=0&id=96e50448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e50448",
  null
  
)

export default component.exports